"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.login = exports.debugExpireTokenValidity = exports.logoutOnUnauthorizedApiError = exports.dismissError = exports.logout = undefined;

var _API = require("../../API");

var _actions = require("../../../reducers/auth/actions");

var baseAuthActions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// directly reuse base auth action creators...
var logout = exports.logout = baseAuthActions.logout;
var dismissError = exports.dismissError = baseAuthActions.dismissError;
var logoutOnUnauthorizedApiError = exports.logoutOnUnauthorizedApiError = baseAuthActions.logoutOnUnauthorizedApiError;
var debugExpireTokenValidity = exports.debugExpireTokenValidity = baseAuthActions.debugExpireTokenValidity;
// inject our own api client and use a specific scope
var login = exports.login = baseAuthActions.login(_API.API, _API.client, "app");


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/auth/actions.ts
 ** module id = 635
 ** module chunks = 0
 **/